import { render } from "./order-info.vue?vue&type=template&id=5ff6f620&scoped=true&ts=true"
import script from "./order-info.vue?vue&type=script&lang=ts"
export * from "./order-info.vue?vue&type=script&lang=ts"

import "./order-info.vue?vue&type=style&index=0&id=5ff6f620&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff6f620"]])

export default __exports__